import { BaseModel } from "../../base.model";
import { AccountStatus } from "../user/user.model";

export class ClientBaseModel extends BaseModel {
    userName: string = "";
    email: string = "";
    name: string = "";
    middleName: string = "";
    lastName: string = "";
    fullName: string = "";
    phoneNumber: string = "";
    number: string = "";
    status: AccountStatus = 0;
    socialId: string = "";
    enabled?: boolean;
    matterNumber: string = "";
    profilePhotoFileId?: string;

    //used only for website pictureloading
    listPhoto?: any;
    
}
